import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/services/global.service';
import { Location } from '@angular/common';
import { IdentityService } from 'src/app/shared/services/identity.service';
import { PointService } from 'src/app/shared/services/point.service';
import { HistoryInfo, MemberPointsDto, PointDetail, PointTransaction } from '../../admin/point-system/point.system.model';
import { AddPoint } from './add-point.system.model';
import { ProfileService } from 'src/app/shared/profile/profile/profile.service';
import { AppService } from 'src/app/shared/services/app.service';
import QRCode from 'qrcode';

@Component({
    selector: 'app-add-point-transaction',
    templateUrl: './add-point-transaction.component.html',
    styleUrls: ['./add-point-transaction.component.scss'],
    standalone: false
})
export class AddPointTransactionComponent implements OnInit, AfterViewInit {
  qrImage: string = '';
  isLoading: boolean = false;
  p: number = 1;
  memberId: number;
  userId: string = null;
  isConfirmed: boolean = false;
  verifyPhone: boolean = false;
  failedToVerify: boolean = true;
  dial_code: string = "+1";
  phoneNumber: string = '';
  data: MemberPointsDto;
  currentPointSystem: number;
  currentActivity: number;
  activities: PointDetail[];
  currentPoint: number = 0;
  currentTask: string = '';
  totalPoints: number = 0;
  currentTaskId: number = 0;
  message: string = "";
  name: string = '';
  adding: boolean = false;
  deducting: boolean = false;
  isQR: boolean = false;
  isDetails: boolean = false;
  UrlLink2Member: string = "";
  displayHistory: any[];
  searchText: string = "";
  loadingData: boolean = false;
  dataChanged: boolean = false;
  isSelf: boolean = false;
  isAdd: boolean = false;

  constructor(private appService: AppService, public globalService: GlobalService, private _router: Router, private _location: Location, private identityService: IdentityService,
    private route: ActivatedRoute, private _pointService: PointService, private profileService: ProfileService
  ) { }

  async ngOnInit() {
    this.isLoading = true;
    // this.globalService.isBack = true;
    this.userId = localStorage.getItem('CSBarcodeID');
    if (this.userId != null && this.userId.length == 36) {
      this.isConfirmed = true;
      this.memberId = parseInt(this.route.snapshot.params.memberId);
      this.isSelf = parseInt(this.route.snapshot.params.self) == 1;
      await this.loadData();
      this.currentPointSystem = this.data.pointSystems[0].id;
      this.updateActivities();
      this.currentActivity = 0;
      this.UrlLink2Member = window.location.href;
      this.qrImage = await QRCode.toDataURL(this.UrlLink2Member);
    }

    this.isLoading = false;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.globalService.title.push(this.globalService.screenHeader);
      this.globalService.screenHeader = this.globalService.Get('POINT_SYSTEM');
    });
  }

  clearCellPhone() {
  }

  failedVerification() {
    this.verifyPhone = false;
    this.failedToVerify = true;
  }

  async ConfirmCellPhone(phoneNumber) {
    this.isLoading = true;
    this.phoneNumber = phoneNumber;
    var user = await this.profileService.getUserIdByPhoneNumber(phoneNumber);
    this.userId = user['userId'];
    if (this.userId != null && this.userId.length == 36) {
      this.isConfirmed = true;
      let tenant = localStorage.getItem('tenant');
      localStorage.setItem('CSBarcodeID', this.userId);
      this.appService.sendToNative(this.userId, tenant);
      this.memberId = parseInt(this.route.snapshot.params.memberId);
      await this.loadData();
      this.currentPointSystem = this.data.pointSystems[0].id;
      this.updateActivities();
      this.currentActivity = 0;
      this.UrlLink2Member = window.location.href;
      this.qrImage = await QRCode.toDataURL(this.UrlLink2Member);
      this.isLoading = false;
    }
  }

  async loadData() {
    this.data = await this._pointService.GetMemberPointInfo(this.userId, this.memberId, this.isSelf);
    if (this.data.pointSystems.length == 0) {
      this.isLoading == false;
      this._router.navigate(['/unauthorized']);
      return;
    }
    this.name = this.data.memberInfo.filter(a => a.id == this.memberId)[0].name;
    this.refreshHistory();
  }

  updateActivities() {
    if (this.currentPointSystem == null || this.currentPointSystem == 0)
      this.activities = [];
    else
      this.activities = this.data.pointDetails.filter(a => a.pointSystemId == this.currentPointSystem);
    this.currentActivity = 0;
    this.calculateTotal();
  }

  refreshHistory() {
    this.data.history.forEach(a => {
      a['taskName'] = this.data.pointDetails.filter(b => b.id == a.taskId)[0].task;
      a['servantName'] = this.data.memberInfo.filter(b => b.id == a.servantId)[0].name;
    });
  }

  updateCurrentPoint() {
    this.message = "";
    let curTask = this.data.pointDetails.filter(a => a.id == this.currentActivity)[0];
    this.currentPoint = curTask.points;
    this.currentTask = curTask.task;
    this.currentTaskId = curTask.id;
  }

  calculateTotal() {
    this.totalPoints = 0;
    if (this.currentPointSystem == null || this.currentPointSystem == 0)
      return;
    var history = this.data.history.filter(a => a.memberId == this.memberId && a.pointSystemId == this.currentPointSystem);
    history.forEach(a => {
      this.totalPoints = this.totalPoints + a.taskPoints;
    });
  }

  async addPoint() {
    this.message = "";
    this.isAdd = true;
    let addpoint: AddPoint;
    this.adding = true;
    addpoint = new AddPoint();
    addpoint.currentUser = this.userId;
    addpoint.memberId = this.memberId;
    addpoint.taskId = this.currentTaskId;
    addpoint.points = this.currentPoint;
    let result = await this._pointService.AddPointsToMember(addpoint);
    if (result == true) {
      this.message = this.currentPoint + " points have been successfully added!";
      this.totalPoints = this.totalPoints + this.currentPoint;
      this.dataChanged = true;
    }
    this.adding = false;
  }

  showBarcode() {
    this.message = "";
    this.isQR = true;
    this.isDetails = false;
  }

  async showDetails() {
    this.message = "";
    this.isQR = false;
    this.p = 1;
    this.searchText = "";
    if (this.dataChanged == true) {
      this.loadingData = true;
      await this.loadData();
      this.dataChanged = false;
    }
    this.displayHistory = [];
    this.data.history.forEach(a => {
      let newRec: HistoryInfo = new HistoryInfo();
      newRec.Date = a.creationDate,
        newRec.Servant = a['servantName'],
        newRec.Task = a['taskName'],
        newRec.Points = a.taskPoints,
        this.displayHistory.push(newRec);
    });
    this.isDetails = true;
    this.loadingData = false;
  }

  async deductPoint() {
    this.message = "";
    let addpoint: AddPoint;
    this.isAdd = false;
    this.deducting = true;
    addpoint = new AddPoint();
    addpoint.currentUser = this.userId;
    addpoint.memberId = this.memberId;
    addpoint.taskId = this.currentTaskId;
    addpoint.points = - this.currentPoint
    let result = await this._pointService.AddPointsToMember(addpoint);
    if (result == true) {
      this.message = this.currentPoint + " points have been successfully deducted!";
      this.totalPoints = this.totalPoints - this.currentPoint;
      this.dataChanged = true;
    }
    this.deducting = false;
  }

  getMessageColor() {
    return this.isAdd == true ? 'primary' : 'danger'
  }

  get filteredHistory() {
    if (!this.displayHistory) return [];

    const search = this.searchText?.trim().toLowerCase();

    if (!search) return this.displayHistory;

    return this.displayHistory.filter(r =>
      (r.name && r.name.toLowerCase().includes(search)) ||
      (r.description && r.description.toLowerCase().includes(search)) ||
      (r.points && r.points.toString().includes(search)) ||
      (r.date && r.date.toString().toLowerCase().includes(search))
    );
  }


  // goFeatures() {
  //   this.globalService.clearCurCache = false;
  //   this._router.navigate(['/home']);
  // }

  // goHome() {
  //   if ((this.isQR == true) ||
  //     (this.isDetails == true)) {
  //     this.isQR = false;
  //     this.isDetails = false;
  //   }
  // }

} 
